// src/pages/HuongDanSuDung/index.tsx
// Màn "Hướng dẫn Sử dụng" — nhúng nguyên trang tài liệu tĩnh (.features/huong-dan-su-dung/index.html,
// đã copy sang public/huong-dan-su-dung/) qua iframe full màn hình. Trang tài liệu có header/sidebar CSS
// riêng (position: fixed, tự tính theo viewport của chính nó) nên không render lại bằng JSX — nhúng
// nguyên bản qua iframe là cách duy nhất giữ đúng layout/hình ảnh gốc mà không cần port lại HTML/CSS.
import React from 'react';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('huong_dan_su_dung');

const HuongDanSuDung: React.FC = () => {
  return (
    <iframe
      title={st('huong_dan_su_dung_title')}
      src={`${process.env.PUBLIC_URL}/huong-dan-su-dung/index.html`}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        border: 'none',
        zIndex: 1050,
      }}
    />
  );
};

export default HuongDanSuDung;
